import { create } from "zustand";

const initialState = {
  batchJobId: "",
  campaignId: "",
  mode: "campaign",
  total: 0,
  count: 0,
  contentDone: 0,
  profileDone: 0,
  accountDone: 0,
  failed: 0,
  skipped: [],
  accountSummary: null,
  isComplete: false,
  isDismissed: false,
};

const PROGRESS_COUNTERS = ["contentDone", "profileDone", "accountDone"];

const applyProgressPatch = (state, patch) => {
  const next = { ...state, ...patch };

  if (patch.total !== undefined) {
    const incomingTotal = Number(patch.total || 0);
    const currentTotal = Number(state.total || 0);
    next.total =
      incomingTotal > 0 ? Math.max(currentTotal, incomingTotal) : currentTotal;
  }

  const total = Number(next.total || state.total || 0);

  const increment = (key, amount) => {
    if (!amount) return;
    next[key] = Math.min(Number(state[key] || 0) + amount, total || Infinity);
  };

  increment("contentDone", patch.incrementContentDone);
  increment("profileDone", patch.incrementProfileDone);
  increment("accountDone", patch.incrementAccountDone);

  delete next.incrementContentDone;
  delete next.incrementProfileDone;
  delete next.incrementAccountDone;

  for (const key of PROGRESS_COUNTERS) {
    if (patch[key] !== undefined) {
      next[key] = Math.max(Number(state[key] || 0), Number(patch[key] || 0));
    }
  }

  return next;
};

export const useEnrollmentBatchToastStore = create((set) => ({
  ...initialState,

  setPatch: (patch) => set((state) => applyProgressPatch(state, patch)),

  reset: () => set(initialState),
}));
